import React from "react";
import { IMAGES } from "../utils/images";
import "../Styles/accordian.css";

const AccordianItem = ({ title, content, subHead, id, isOpen, setIsOpen }) => {
  const handleClick = () => {
    setIsOpen(isOpen != isOpen);
  };

  return (
    <div className="accordion">
      <div className="accordion-top" onClick={handleClick}>
        <h1 className="accordion-top-tittle">{title || subHead}</h1>
        <div className="accordion-top-icon">
          {!isOpen ? (
            <img src={IMAGES.CHEVRON_DOWN} />
          ) : (
            <img src={IMAGES.CHEVRON_UP} />
          )}
        </div>
      </div>
      {isOpen && <p className="accordion-bottom">{isOpen && <>{content}</>}</p>}
    </div>

    // {/* </div> */}
  );
};

export default AccordianItem;
